export function renderParticipantLimit(isNoLimit, minimumParticipantLimit, maximumParticipantLimit) {
  let show
  if (!isNoLimit) {
    if (minimumParticipantLimit && maximumParticipantLimit) {
      show = `${minimumParticipantLimit} - ${maximumParticipantLimit}`
    } else if (minimumParticipantLimit && !maximumParticipantLimit) {
      show = `${minimumParticipantLimit} - no limit`
    } else if (!minimumParticipantLimit && maximumParticipantLimit) {
      show = `0 - ${maximumParticipantLimit}`
    } else {
      show = ''
    }
  } else {
    show = 'No Limit'
  }
  return show
}
